import React from 'react';

// Subtle site-wide trust badge — illustrated (generic) advisor avatars + credibility line.
const AVATARS = [
  'https://static.prod-images.emergentagent.com/jobs/eacef848-09ed-42bb-afb1-f03db3655f08/images/d441282cf0a9ad72fde6eb46a34f4b247235ea89413dcbcbafe5429a6d44ca06.jpeg',
  'https://static.prod-images.emergentagent.com/jobs/eacef848-09ed-42bb-afb1-f03db3655f08/images/588ece13ca6a0465beda79b0e3d513a8b420d164cdc215e69de6f4cfa3cc1d04.jpeg',
  'https://static.prod-images.emergentagent.com/jobs/eacef848-09ed-42bb-afb1-f03db3655f08/images/ef52759845b2d9a402d916be205d8174a682e405568552853a6fc349396f7adf.jpeg',
];

export const ExpertBadge = ({
  variant = 'light',
  align = 'center',
  className = '',
}) => {
  const dark = variant === 'dark';
  const ring = dark ? 'ring-gray-900' : 'ring-white';
  const title = dark ? 'text-white' : 'text-gray-900';
  const sub = dark ? 'text-gray-400' : 'text-gray-500';
  const justify = align === 'left' ? 'justify-start' : 'justify-center';

  return (
    <div
      data-testid="expert-trust-badge"
      className={`inline-flex items-center gap-3 ${justify} ${className}`}
    >
      <div className="flex -space-x-2.5">
        {AVATARS.map((src, i) => (
          <img
            key={i}
            src={src}
            alt=""
            aria-hidden="true"
            loading="lazy"
            className={`w-8 h-8 rounded-full object-cover ring-2 ${ring} bg-gray-100`}
          />
        ))}
      </div>
      <div className="text-left leading-tight">
        <p className={`text-[13px] sm:text-sm font-bold ${title}`}>
          Trusted by Aussie households
        </p>
        <p className={`text-[11px] sm:text-xs ${sub}`}>Helping families cut power bills</p>
      </div>
    </div>
  );
};
